import { ComponentRef, Directive, ElementRef, Input, Renderer2, TemplateRef } from '@angular/core';

@Directive({
  selector: '[appNavigationContent]',
})
export class NavigationContentDirective {
  constructor(public template: TemplateRef<unknown>, public elementRef: ElementRef) {}
}
